"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Graph = function Graph(props) {
  return _react2["default"].createElement("svg", (0, _extends3["default"])({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _react2["default"].createElement("path", {
    d: "M4.354 6C5.059 5.378 5.985 5 7 5c1.017 0 1.946.38 2.652 1.005l1.917-1.917a2.5 2.5 0 1 1 .355.353l-1.92 1.918C10.625 7.064 11 7.988 11 9a3.985 3.985 0 0 1-1 2.646l.774.774a2 2 0 1 1-.354.354L9.646 12c-.705.622-1.631 1-2.646 1a3.985 3.985 0 0 1-2.658-1.01l-1.629 1.628a1.5 1.5 0 1 1-.357-.35l1.634-1.634A3.985 3.985 0 0 1 3 9c0-1.015.378-1.941 1-2.646L2.37 4.723a1.5 1.5 0 1 1 .354-.354L4.353 6z",
    className: "fill"
  }));
};

exports["default"] = Graph;